module.exports = __webpack_public_path__ + "static/contact-5d00af7d6b02166da5c0081df88a7bc9.jpg";